import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { dashboardRoute, getRoutesByRole } from "../navbar/routes";

export default function SignUp() {
  const { authenticated, register, initialized, role } = useAuth();
  const location = useLocation();
  const routes = getRoutesByRole(role);

  useEffect(() => {
    if (initialized && !authenticated) {
      register({
        redirectUri: `${window.location.origin}${dashboardRoute.path}`,
      });
    }
  }, [initialized, authenticated]);

  return authenticated ? (
    <Navigate to={routes[0].path} state={{ from: location }} replace />
  ) : (
    <div>Redirecting...</div>
  );
}
